var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p404 pa-5"},[_c('div',[_c('h1',{staticClass:"display-4 font-weight-black"},[_vm._v("404")]),_c('p',{staticClass:".display-3"},[_c('v-icon',[_vm._v("error")]),_vm._v(" Страница не найдена ")],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }